'use es6';

import { usageTracker } from './usageTracker';
export const trackCsatSurveyRender = ({
  itemId,
  itemName
}) => {
  usageTracker.track('Cem', 'In Moment Survey Rendered', {
    itemId,
    itemName,
    itemType: 'csat'
  });
};
export const trackCesSurveyRender = ({
  itemId,
  itemName
}) => {
  usageTracker.track('Cem', 'In Moment Survey Rendered', {
    itemId,
    itemName,
    itemType: 'ces'
  });
};
export const trackNpsSurveyRender = () => {
  usageTracker.track('Cem', 'In Moment Survey Rendered', {
    itemType: 'nps'
  });
};